<template>
    <div ref="chat">
        <div v-for="(group, groupIndex) in messageByDays">
            <div style="display: flex; justify-content: center">
                <q-chip color="blue" text-color="white">
                    <template
                        v-if="
                            new Date().getDate() -
                                new Date(group.day).getDate() ==
                            0
                        "
                    >
                        Today
                    </template>
                    <template v-else>
                        {{ group.day }}
                    </template>
                </q-chip>
            </div>

            <q-chat-message
                v-for="(message, index) in group.messages"
                :key="index"
                :text="message.text"
                :sent="!message.sent"
                :bg-color="message.sent ? 'grey-4' : 'indigo'"
                :text-color="message.sent ? 'black' : 'white'"
                :stamp="message.displayTime"
            ></q-chat-message>
        </div>
    </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import {
    inject,
    nextTick,
    onMounted,
    onUnmounted,
    watch,
} from "@vue/runtime-core";
import { BASE_PATH, emitter } from "@/main";
import axios from "axios";
import { useRoute } from "vue-router";
import { date, useQuasar } from "quasar";

export default {
    setup() {
        const messages = ref([]);
        const messageByDays = ref([]);
        const messageInput = inject("messageInput");
        const route = useRoute();
        const lastMessage = ref(0);

        const intervalCall = setInterval(() => {
            // getMessageChuck();
        }, 5000);

        const patient = JSON.parse(localStorage.getItem("USER"));
        const $q = useQuasar();
        const chat = ref(null);

        let socket = inject("socket");
        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (typeof data.data == "string") {
                const message = JSON.parse(data.data);
                if (
                    message.terminal == "cycle" &&
                    message.receiver_id == patient.Id
                ) {
                    getMessageChuck()
                        .then(() => {
                            scrollToBottom();
                        })
                        .catch((err) => {
                            $q.dialog({
                                title: "Alert",
                                message: "You have message in another thread",
                            })
                                .onOk(() => {})
                                .onDismiss(() => {});
                        });
                }
            }
        };

        const sendMessage = async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.post(`${BASE_PATH}/compose-sms`, {
                    userId: patient.Id,
                    message: messageInput.value,
                    parent: route.params.id,
                    subject: "Test",
                });
                let msg = { text: [messageInput.value], sent: false };
                // messages.value = [...messages.value, msg];
                getMessage();

                socket.send(
                    JSON.stringify({
                        sender_id: patient.Id,
                        receiver_id: 1,
                        terminal: "nlp",
                    })
                );
                setTimeout(() => {
                    scrollToBottom();
                }, 100);
            } catch (err) {
            } finally {
                messageInput.value = "";
            }
        };

        const getMessage = async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.get(
                    `${BASE_PATH}/get-message-record`,
                    { params: { id: route.params.id, patientId: patient.Id } }
                );

                lastMessage.value = data.lastPulledId;
                groupMessageByDay(data.messageRecords);

                const resp = await axios.post(`${BASE_PATH}/read-messages`, {
                    id: data.messageRecords[data.messageRecords.length - 1].id,
                    parentId: route.params.id,
                    patientId: patient.Id,
                });
                scrollToBottom();
            } catch (err) {
                console.log(err);
            }
        };

        const scrollToBottom = () => {
            window.scrollTo(0, chat.value.scrollHeight);
        };

        const getMessageChuck = async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.get(
                    `${BASE_PATH}/get-message-record-chunk`,
                    {
                        params: {
                            id: route.params.id,
                            patientId: patient.Id,
                            lastPulledId: lastMessage.value,
                        },
                    }
                );
                messages.value = [...messages.value, ...data.messages];
                lastMessage.value = data.lastPulledId;
                return Promise.resolve();
            } catch (err) {
                return Promise.reject();
            }
        };

        const groupMessageByDay = (msgs) => {
            let _msgs = msgs.map((item) => {
                let msgDate = new Date(
                    `${item.time.split(" ")[0]}T${item.time.split(" ")[1]}`
                );

                return {
                    ...item,
                    day: item.time.split(" ")[0],
                    displayTime: date.formatDate(msgDate, "hh:mm:a"),
                };
            });

            const groupedByDay = _msgs.reduce((group, item) => {
                const { day } = item;
                group[day] = group[day] ?? [];
                group[day].push(item);
                return group;
            }, {});

            messageByDays.value = Object.entries(groupedByDay).map((item) => ({
                day: item[0],
                messages: item[1],
            }));
        };

        onMounted(() => {
            getMessage();
            emitter.on("send-message", sendMessage);
        });

        onUnmounted(() => {
            emitter.off("send-message", sendMessage);
            clearInterval(intervalCall);
            socket.onmessage = null;
        });

        return { messages, chat, messageByDays };
    },
};
</script>
